<script lang="ts">
  import { SITE_CONTACT } from '~/lib/site-contact'
  import { siteContainerClass } from '~/app/site-theme'
  import SiteLogoMark from '~/components/site/SiteLogoMark.svelte'
  import { siteCsaNavLink, siteInfoNavLinks } from '~/lib/site-info-nav'

  const year = new Date().getFullYear()

  const footerInfoLinks = [
    ...siteInfoNavLinks,
    { href: '/reviews', label: 'Отзывы' },
    { href: '/privacy', label: 'Конфиденциальность' },
  ]

  const catalogLinks = [
    { href: siteCsaNavLink.href, label: siteCsaNavLink.label },
    { href: '/catalog', label: 'Все позиции' },
    { href: '/catalog#cat-kapusty', label: 'Капусты' },
    { href: '/catalog#cat-korneplody', label: 'Корнеплоды' },
    { href: '/catalog#cat-pertsy', label: 'Перцы' },
    { href: '/catalog#cat-salaty', label: 'Салаты и зелень' },
  ]
</script>

<footer class="border-t border-[rgba(122,181,71,0.15)] bg-[#060d07]">
  <div class="{siteContainerClass} grid gap-10 py-12 sm:grid-cols-2 lg:grid-cols-4">
    <!-- Brand -->
    <div class="lg:col-span-2">
      <div class="flex items-center">
        <SiteLogoMark class="size-[120px]" />
      </div>
      <p class="mt-3 max-w-xs text-sm leading-relaxed text-[#f4f8f1]">
        Фермерские овощи в грунте без ускорителей роста — для ресторанов и ценителей вкуса.
        Более 35 культур, Подмосковье.
      </p>
      <div class="mt-5 space-y-2 text-sm">
        <a
          href={SITE_CONTACT.phoneHref}
          class="flex items-center gap-2 text-[#f4f8f1] transition-colors hover:text-[#7AB547]"
        >
          <svg class="size-4 shrink-0" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.64A2 2 0 012 1h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 8.09a16 16 0 006 6l1.42-1.42a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 14.92z"/>
          </svg>
          {SITE_CONTACT.phone}
        </a>
        <a
          href={SITE_CONTACT.emailHref}
          class="flex items-center gap-2 text-[#f4f8f1] transition-colors hover:text-[#7AB547]"
        >
          <svg class="size-4 shrink-0" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
          </svg>
          {SITE_CONTACT.email}
        </a>
        <p class="flex items-center gap-2 text-[#dfe8d8]">
          <svg class="size-4 shrink-0" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
          </svg>
          {SITE_CONTACT.address}
        </p>
      </div>
    </div>

    <!-- Info links -->
    <div>
      <p class="mb-4 text-xs font-semibold uppercase tracking-widest text-[#dfe8d8]">
        Информация
      </p>
      <ul class="space-y-2.5">
        {#each footerInfoLinks as link (link.href)}
          <li>
            <a
              href={link.href}
              class="text-sm text-[#f4f8f1] transition-colors hover:text-white"
            >
              {link.label}
            </a>
          </li>
        {/each}
      </ul>
    </div>

    <!-- Catalog links -->
    <div>
      <p class="mb-4 text-xs font-semibold uppercase tracking-widest text-[#dfe8d8]">Каталог</p>
      <ul class="space-y-2.5">
        {#each catalogLinks as link (link.href)}
          <li>
            <a
              href={link.href}
              class="text-sm text-[#f4f8f1] transition-colors hover:text-white"
            >
              {link.label}
            </a>
          </li>
        {/each}
      </ul>
      <div class="mt-6">
        <a
          href="/register"
          class="inline-flex rounded-xl bg-[#7AB547]/15 px-4 py-2 text-sm font-medium text-[#7AB547] transition-colors hover:bg-[#7AB547]/25"
        >
          Стать клиентом
        </a>
      </div>
    </div>
  </div>

  <!-- Bottom bar -->
  <div class="border-t border-[rgba(122,181,71,0.1)] py-4">
    <div class="{siteContainerClass} flex flex-wrap items-center justify-between gap-2 text-xs text-[#dfe8d8]">
      <span>© Суперфуд Фарм {year}</span>
      <div class="flex items-center gap-4">
        <a href="/privacy" class="hover:text-[#7AB547]">Конфиденциальность</a>
      </div>
    </div>
  </div>
</footer>
